import Auth from "./auth";
import moment from "moment";

class Devices {

    constructor() {
      if (!Auth.g()) {
        this.unstore();
      }
    }

    pull(){
      axios.get(`/api/switch/`).then(res => {
        if (res.data) {
          this.store(res.data);
        }
        return res.data;
      }).catch(err => {
        console.error(err);
      });
    }

    store(items){
      items = btoa(unescape(encodeURIComponent(JSON.stringify(items))));
      localStorage.setItem('mydata', items);
    }

    get(item = false){
      let items = localStorage.getItem('mydata');
      if (items) {
        items = JSON.parse(decodeURIComponent(escape(window.atob(items))));
        if (item) {
          return items[item];
        }
        return items;
      } else {
        return null;
      }
    }


    unstore(){
      localStorage.removeItem('mydata');
    }

    analyze(items){
      for (let item in items) {
        items[item] = this.analyzeItem(items[item]);
      }
      return items;
    }

    analyzeItem(item, name = true){
      // console.log('');
      // console.log('________________');
      // console.log(item.identifier, name);
      if (item.data && Object.keys(item.data).length) {

        const OLD = this.get(item.slug)
        const RENAME = item.name

        item.name = OLD && OLD.name ? OLD.name : RENAME
        if (name && RENAME) {
          item.name = RENAME
        }
        if (item.name) {
          localStorage.setItem(item.slug+'-name', item.name)
        } else {
          let OLDNAME = localStorage.getItem(item.slug+'-name')
          if (OLDNAME) {
            item.name = OLDNAME
          }
        }

        // console.log('updated:', item.name);
        item.data = this.fixType(item.data, item.type);
        item.connection = this.checkConnection(item.data.received);
        if (item.connection === false){
          item.status = 'Offline';
        } else {
          if (item.role == 0 && item.data.dudtype < 4) {
            item.exceeds = this.exceeds(item.data);
            item.status  = item.exceeds ? 'Off' : 'On';
          } else {
            if (item.data.dudtype == 4) {
              if (item.role == '0') {
                if ('drycontact' in item.data) {
                  item.status = item.data.drycontact == 1 ? 'Off' : 'On';
                } else if ('hall' in item.data) {
                  item.status = item.data.hall == 1 ? 'On' : 'Off';
                }
              } else {
                item.status = this.setStatus(item.data);
              }
            } else {
              item.status = this.setStatus(item.data);
            }
          }
        }
        item.sensors = true;
        if (!item.type || item.type == 1) {
          item.sensors = (item.data.dudtype > 0 && !item.data.temperatures[0]) ? false : true;
        }
        item.devmodes = this.getDevmodes(item.data.dudtype);
        item.data.schedule = this.fixSchedule(item.data.schedule);
        item.current_schedule = this.getCurrentSchedule(item.data.schedule);
        item.last_update = item.received ? moment(item.received).format('HH:mm:ss DD/MM/YYYY') : null;
      } else {
        item.connection = false;
        item.status = 'Offline';
        item.data = {
          humidity: 0,
          schedule: [{}],
          liters: [],
          temperatures: [],
          light: 0,
          output1: 0,
          dudtype: 0,
          devmode: 0,
          timeoffset: 0,
          switch1threshold: 0,
        };
      }
      return item;
    }

    fixType(data, type){
      if (!type) {
        if (data.temperatures[0] === 200) {
          data.dudtype = 4;
          data.drycontact = 0;
        }
        if (data.temperatures[0] === 210) {
          data.dudtype = 4;
          data.drycontact = 1;
        }
      } else if (type == 2) {
        if (data.temperatures) {
          data.dudtype = 1
        }
        if (data.humidity) {
          data.dudtype = 2
        }
        if (data.type.sub == 'M') {
          data.dudtype = 4
        }
        if (data.type.sub == 'H') {
          data.dudtype = 4
        }
      } else if (type == 3 && data.type == 4) {
        data.dudtype = 4
      }
      return data;
    }

    checkConnection(time){
      let diff = new Date((new Date(time * 1000) - new Date()));
      diff = Math.floor((diff/1000)/60);
      if ((-12) > diff) {
        return false;
      } else {
        return true;
      }
    }

    setStatus(data){
      const param = data.status ? data.status : data.output1;
      switch (param) {
        case 0:
          return 'Off';
          break;
        case 1:
          return 'On';
          break;
      }
    }

    checkContact(temperature){
      if (temperature === 200){
        return status = 'On'
      } else {
        return status = 'Off'
      }
    }

    exceeds(data){
      let type = null;
      let devmode = data.devmode;
      let threshold = data.threshold ? data.threshold : data.switch1threshold;
      // Devmodes: Timer, Heating, Cooling, Increasing humidity, Decreasing humidity, Turning light on, Turning light off
      if ([1,3,5].includes(devmode)) {
        if (devmode === 1) {
          if (data.temperatures[0] <= threshold) {
            type = 'temperature';
          }
        } else if (devmode === 3) {
          if (data.humidity <= threshold) {
            type = 'humidity';
          }
        } else if (devmode === 5) {
          if (data.light <= threshold) {
            type = 'light';
          }
        }
      } else if ([2,4,6].includes(devmode)){
        if (devmode === 2) {
          //               30      >=    10
          if (data.temperatures[0] >= threshold) {
            type = 'temperature';
          }
        } else if (devmode === 4) {
          if (data.humidity >= threshold) {
            type = 'humidity';
          }
        } else if (devmode === 6) {
          if (data.light >= threshold) {
            type = 'light';
          }
        }
      }
      return type;
    }

    getDevmodes(dudtype){
      let devmodes = 0;
      switch (dudtype) {
        case 1:
          devmodes = 3;
          break;
        case 2:
          devmodes = 5;
          break;
        case 3:
          devmodes = 7;
          break;
      }
      return devmodes;
    }

    fixSchedule(schedule){
      let fixed = [];
      for (let sched in schedule){
        if (schedule[sched].days.length) {
          fixed.push(schedule[sched]);
        }
      }
      return fixed;
    }

    getCurrentSchedule(schedule){
      let now = new Date();
      let day = now.getDay() + 1;
      let hour = now.getHours();
      let minutes = now.getMinutes();

      for (let sched in schedule){
        let s = schedule[sched];
        if (s.days.includes(day)){

          // Check start at
          let time = s.start_at.split(':');
          if (time[0] <= hour) {
            if (time[0] < hour || time[1] <= minutes) {

              // Check end at
              time = s.end_at.split(':');
              if (time[0] >= hour) {
                if (time[0] > hour || time[1] >= minutes) {
                  return s;
                }
              }

            }
          }

        }
      }
    }

}

export default Devices = new Devices()
